export default "__VITE_ASSET__363f9f08__"